import helper from '../../../helpers/steinerHelper';

export const actionTypes = helper.createActionTypes('portaliArchivioMail');
export const actions = helper.createActions('portaliArchivioMail', actionTypes);
